import { Icon, getSvgIcon } from '@helpers/icons';
import { withMotionMax } from '@hoc/withMotionMax';
import { FakeButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import CtaBlock from '../CtaBlock/CtaBlock';
import GroupLink, { GroupLinkBlock, useGetGroupColourVars, } from '../GroupLink/GroupLink';
import NavigationContactBlock from '../NavigationContactBlock/NavigationContactBlock';
import NavigationImage from '../NavigationImage/NavigationImage';
import S from './MobileNavigation.styles';
import HeaderStyles from '../Header.styles';
const menuVariants = {
    initial: { x: `100%`, pointerEvents: 'none' },
    open: { x: 0, transitionEnd: { pointerEvents: 'all' } },
};
const MobileNavigation = (props) => {
    const [active, setActive] = React.useState(-1);
    React.useEffect(() => {
        if (!props.open) {
            setActive(-1);
        }
    }, [props.open]);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, { variants: menuVariants, initial: "initial", animate: props.open ? 'open' : 'initial', transition: { type: 'spring', stiffness: 120, damping: 16 } },
            React.createElement(S.TopLevel, null,
                React.createElement("ul", null, props.items.map((item, i) => {
                    const hasChildren = item.children && item.children.length > 0;
                    return (React.createElement(S.MenuItem, { key: `mobile-nav-${i}-${item.text}` },
                        React.createElement(S.MenuLink, { ...(hasChildren
                                ? { as: 'button', onClick: () => setActive(i) }
                                : { href: item.url, target: item.target }) },
                            item.text,
                            hasChildren && getSvgIcon(Icon.Chevron))));
                }))),
            props.items.map((item, i) => (React.createElement(LevelTwo, { key: `mobile-nav-${i}-${item.text}-level-two`, item: item, active: active === i, goBack: () => setActive(-1) }))),
            React.createElement(NavigationContactBlock, { email: props.email, socialLinks: props.socialLinks, telephone: props.telephone, translations: props.translations, as: "div" })),
        React.createElement(S.Bg, { "data-close": true, variants: menuVariants, initial: "initial", animate: props.open ? 'open' : 'initial', transition: { type: 'spring', stiffness: 120, damping: 16 }, onClick: props.onClose })));
};
const LevelTwo = ({ item, active, goBack }) => {
    const [activeChild, setActiveChild] = React.useState('');
    const colours = useGetGroupColourVars(item);
    React.useEffect(() => {
        if (!active) {
            setActiveChild('');
        }
    }, [active]);
    if (!item.children || item.children.length === 0) {
        return null;
    }
    const singleChild = item.children && item.children.length === 1;
    return (React.createElement(React.Fragment, null,
        React.createElement(S.MenuList, { variants: menuVariants, initial: "initial", animate: active ? 'open' : 'initial', transition: { type: 'spring', stiffness: 120, damping: 16 } },
            React.createElement(S.MenuItem, null,
                React.createElement(BackButton, { onClick: goBack, label: item.text })),
            singleChild ? (React.createElement(React.Fragment, null,
                React.createElement(S.MenuItem, null,
                    React.createElement(GroupLinkBlock, { item: item.children?.[0], colours: colours?.[0] })),
                React.createElement(ColumnLinks, { label: item.text, items: item.children?.[0].children }))) : (React.createElement(React.Fragment, null, item.children.map((child, i) => (React.createElement(S.MenuItem, { key: `mobile-nav-${i}-${child.text}` },
                React.createElement(GroupLink, { item: child, active: activeChild === child.id, colours: colours?.[i], onClick: () => setActiveChild(child.id) })))))),
            item.ctaBlock && (React.createElement(S.MenuItem, null,
                React.createElement(CtaBlock, { ...item.ctaBlock }))),
            singleChild && item.children?.[0].image ? (React.createElement(S.MenuItem, null,
                React.createElement(NavigationImage, { ...item.children?.[0].image }))) : null),
        !singleChild && (React.createElement(React.Fragment, null, item.children.map((child, i) => (React.createElement(LevelThree, { key: `mobile-nav-${i}-${child.text}-level-three`, active: activeChild === child.id, colours: colours?.[i], goBack: () => setActiveChild(''), item: child })))))));
};
const LevelThree = ({ active, item, goBack, colours }) => {
    if (!item.children || item.children.length === 0) {
        return null;
    }
    return (React.createElement(S.MenuList, { variants: menuVariants, initial: "initial", animate: active ? 'open' : 'initial', transition: { type: 'spring', stiffness: 120, damping: 16 } },
        React.createElement(S.MenuItem, null,
            React.createElement(BackButton, { onClick: goBack, label: item.label })),
        React.createElement(S.MenuItem, null,
            React.createElement(GroupLinkBlock, { item: item, colours: colours })),
        React.createElement(ColumnLinks, { label: item.text, items: item.children }),
        item.image && (React.createElement(S.MenuItem, null,
            React.createElement(NavigationImage, { ...item.image })))));
};
const ColumnLinks = ({ label, items }) => {
    if (!items || items.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null, items.map((child, i) => (React.createElement(React.Fragment, { key: `mobile-nav-${label}-column-${i}` },
        child.title &&
            (child.url ? (React.createElement(HeaderStyles.StyledLink, { href: child.url },
                React.createElement(S.MenuItem, { "data-column-title": true, "data-column-ft": i === 0 }, child.title))) : (React.createElement(S.MenuItem, { "data-column-title": true, "data-column-ft": i === 0 }, child.title))),
        child.items?.map((subChild, j) => (React.createElement(S.MenuItem, { key: `mobile-nav-${label}-column-${i}-link-${j}-${subChild.text}` },
            React.createElement(S.MenuLink, { href: subChild.url, target: subChild.target }, subChild.text)))))))));
};
const BackButton = ({ onClick, label }) => {
    return (React.createElement(S.BackButton, { onClick: onClick },
        React.createElement(FakeButton, { buttonType: "solid-white", iconOnly: true, icon: Icon.ChevronRight, iconPosition: "left" }, "Back"),
        label));
};
export default withMotionMax(MobileNavigation);
